

























































































































































































































































import Vue from 'vue';
import API, { ApiResult } from '@/api/common';
import util from '@/components/util';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/account';
import * as appModels from '@/class/models/views/app';
import * as usermodels from '@/class/models/views/setting/users';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';
import SideMenu from '@/components/util/SideMenu.vue';
import account from '@/parts/account';
import {getAddressData} from '@/api/util/zipcloud';
import ModalFormDataCheck from '@/components/util/ModalFormDataCheck.vue';

import NewVariableInput, {INewVariableInput} from '@/components/util/NewVariableInput.vue';
import { INPUT_TYPE } from '@/components/util/input_type';

// validation
import * as validation from '@/personal/validation';
import * as NOCArray from '@/personal/array';
import {fncChangeStringToJPFormatNonZero} from '@/class/common/moment';


// 都道府県リスト
const PREF_LIST = NOC.PREFECTURE.getOptions();

export default Vue.extend({
  name: 'SubscriberInfo',
  components: {
    ...util, VariableInput, ...account, NewVariableInput, ModalFormDataCheck,  SideMenu,
  },
  data() {
    return {
      onload: false,

      formDataChangeFlg: false,
      formDataChangeFlgModal: false,
      editUserChangeFlg: false,

      editFlag: false,
      accountEditFlag: false,
      accountData: {} as models.IAccount,
      formData: {} as models.IAccount,
      items: [
        {key: 'companyName', name: '会社名', type: vi.INPUT_TYPE.TEXT, placeholder: '会社名', required: true, checks: [], error: '', max: 100},
        {key: 'branchName', name: '支社名', type: vi.INPUT_TYPE.TEXT, placeholder: '支社名', required: false, checks: [], error: '', max: 100},
        {key: 'postalCode', name: '郵便番号', type: vi.INPUT_TYPE.TEXT, placeholder: '150-0001', required: true, checks: [vi.CHECK_TYPE.POSTAL_CODE], error: '', min: 7, max: 8, class: 'postcode'},
        {key: 'postalCodeButton', name: 'ダミー', class: 'postcode-btn'},
        {key: 'prefCode', name: '都道府県', type: vi.INPUT_TYPE.SELECT, placeholder: '都道府県', required: true, error: '', options: PREF_LIST, class: 'addresses'},
        {key: 'address', name: '市区町村・番地', type: vi.INPUT_TYPE.TEXT, placeholder: '市区町村・番地', required: true, checks: [], error: '', max: 100, class: 'addresses'}, // 旧：住所
        {key: 'building', name: '建物名', type: vi.INPUT_TYPE.TEXT, placeholder: '建物名', required: false, checks: [], error: '', max: 60, class: 'addresses'},
        {key: 'mail', name: 'メールアドレス', placeholder: 'メールアドレス', required: true, checks: [vi.CHECK_TYPE.EMAIL], error: '', disabled: true, class: 'mail'},
        {key: 'billingMail', name: '請求先\nメールアドレス', placeholder: '請求先メールアドレス', required: false, checks: [vi.CHECK_TYPE.EMAIL], error: '', disabled: false},
        {key: 'tel', name: '電話番号', type: vi.INPUT_TYPE.TEXT, placeholder: '電話番号', required: true, checks: [vi.CHECK_TYPE.TEL], error: '', min: 10, max: 20},
        {key: 'agencyName', name: '代理店名', type: vi.INPUT_TYPE.TEXT, placeholder: '代理店名', required: false, checks: [], error: '', max: 100, disabled: true, class: 'agency_name'},
      ] as vi.IVariableInput[],
      // items2: [
      //   {key: 'usesrname', name: '名前', placeholder: '', required: true, checks: [vi.INPUT_TYPE.TEXT], error: '', disabled: false},
      //   {key: 'usesrnameKana', name: 'フリガナ', placeholder: '', required: true, checks: [vi.INPUT_TYPE.TEXT], error: '', disabled: false},
      //   {key: 'mail', name: 'メールアドレス', placeholder: '', required: true, checks: [vi.CHECK_TYPE.EMAIL], error: '', disabled: false},
      //   {key: 'gender', name: '性別', placeholder: '', required: false, checks: [vi.INPUT_TYPE.TEXT], error: '', disabled: false},
      //   {key: 'birthday', name: '生年月日', placeholder: '', required: false, checks: [vi.CHECK_TYPE.DATE], error: '', disabled: false},
      // ] as vi.IVariableInput[],

      // items2: [
      //   {key: 'mail', name: 'メールアドレス' },
      //   {key: 'other', name: 'その他' },
      // ],
      editProfile2: [
        {key: 'sei', name: '', placeholder: '姓', type: INPUT_TYPE.TEXT, required: true, error: 'sss', class: 'name', max: 40, display: true},
        {key: 'mei', name: '', placeholder: '名', type: INPUT_TYPE.TEXT, required: true, error: '', class: 'name mei', max: 40, display: true},
        {key: 'sei_kana', name: '', placeholder: 'セイ', type: INPUT_TYPE.TEXT, required: true, error: '', class: 'name', checks: [validation.CHECK_TYPE.KANA], max: 40},
        {key: 'mei_kana', name: '', placeholder: 'メイ', type: INPUT_TYPE.TEXT, required: true, error: '', class: 'name mei', checks: [validation.CHECK_TYPE.KANA], max: 40},
      ] as INewVariableInput[],
      editProfile: [
        {key: 'mail', name: '', placeholder: 'メールアドレス', type: INPUT_TYPE.TEXT, required: true, error: '', class: 'col-12 mail', checks: [validation.CHECK_TYPE.EMAIL], max: 40,  display: true},
        {key: 'gender', name: '', type: INPUT_TYPE.RADIO, required: false, class: 'col-12 gender', options: NOCArray.GENDER},
        {key: 'birthday', name: '', placeholder: '19901230', type: INPUT_TYPE.TEXT, required: false, error: '', class: 'col-12 birth', checks: [validation.CHECK_TYPE.BIRTHDAY]},
      ] as INewVariableInput[],
      // editProfile: [
      //   {key: 'sei', name: '氏名', placeholder: '姓', type: INPUT_TYPE.TEXT, required: true, error: '', class: 'name', max: 40, display: true},
      //   {key: 'mei', name: '', placeholder: '名', type: INPUT_TYPE.TEXT, required: true, error: '', class: 'name mei', max: 40, display: true},
      //   {key: 'seiKana', name: 'フリガナ', placeholder: 'セイ', type: INPUT_TYPE.TEXT, required: true, error: '', class: 'name', checks: [validation.CHECK_TYPE.KANA], max: 40},
      //   {key: 'meiKana', name: '', placeholder: 'メイ', type: INPUT_TYPE.TEXT, required: true, error: '', class: 'name mei', checks: [validation.CHECK_TYPE.KANA], max: 40},
      //   {key: 'mail', name: 'メールアドレス', placeholder: 'メールアドレス', type: INPUT_TYPE.TEXT, required: true, class: 'col-12 mail', checks: [validation.CHECK_TYPE.EMAIL], max: 40,  display: true},
      //   {key: 'gender', name: '性別', type: INPUT_TYPE.RADIO, required: false, class: 'col-12 gender', options: NOCArray.GENDER},
      //   {key: 'birthday', name: '生年月日', placeholder: '1990年1月1日', type: INPUT_TYPE.DATE, required: false, class: 'col-12 birth', checks: [validation.CHECK_TYPE.DATE]},
      // ] as INewVariableInput[],
      editUser: {} as usermodels.IUser,
      editUser2: {} as usermodels.IUser,
      // プロフィールの変更有無の確認用
      editBeforeUser: {} as usermodels.IUser,
      // DatePickerDate: 'yyyy年MM月dd日',
      selectUser: {} as usermodels.IUser,

      // mode: NOC.SETTING.MODE.SELECT,
      changeModal: false,
    };
  },
  computed: {
    // 計算値　ユーザ画面表示要に変換値
    DISP_SELECT_USER() {
      let dispSelectUser = {} as usermodels.IUser;
      // console.log(this.selectUser.workstyleID);
      dispSelectUser = JSON.parse(JSON.stringify(this.selectUser));
      // 表示用にデータを変換
      dispSelectUser.roleText = NOCArray.getOptionsText(NOCArray.ROLE, dispSelectUser.role);
      dispSelectUser.genderText = NOCArray.getOptionsText(NOCArray.GENDER, this.selectUser.gender);
      if (this.selectUser.birthday) {
        dispSelectUser.birthday = fncChangeStringToJPFormatNonZero(this.selectUser.birthday);
      }
      return dispSelectUser;
    },

  },
  async mounted() {
    // データ取得
    const api = new API();
    const res = await api.get<models.IAccount>('account');

    if (res.result) {
      this.accountData = res.data;
      this.formData = JSON.parse(JSON.stringify(this.accountData));
    } else {
      this.$emit('change', NOC.APP.MODE.LOGIN);
    }
    this.$emit('pushPath', this.$route.path);

    // this.mode = NOC.SETTING.MODE.CHARGE;
    // アカウント管理者のユーザー情報を取得
    const resUser = await api.get<usermodels.VEditUserProfile>('users/accountmanager');
    if (resUser.result) {
      this.selectUser = resUser.data.user;
      // this.mode = NOC.SETTING.MODE.SELECT;
    } else {
      this.$emit('change', NOC.APP.MODE.LOGIN);
    }

    // 読み込み完了
    this.onload = true;
  },
  beforeDestroy() {
    const payjpCheckoutIframeEl: any = document.getElementById('payjp-checkout-iframe');
    if (payjpCheckoutIframeEl) {
      payjpCheckoutIframeEl.parentElement.remove();
    }
  },
  methods: {
    // プロフィールの編集ボタン押下時処理
    onClickEditProfile() {
      window.scrollTo(0, 0);
      this.editUser = JSON.parse(JSON.stringify(this.selectUser));
      // this.mode = NOC.SETTING.MODE.EDIT_PROFILE;

      this.adjustBirthdayString();
      // 編集前と比較するため、編集前の内容をコピー
      this.editBeforeUser = {...this.editUser};
    },
    adjustBirthdayString() {
      const birthday = new Date(this.editUser.birthday);
      const year = String(birthday.getFullYear());
      let month = String(birthday.getMonth() + 1);
      let date = String(birthday.getDate());

      if (month.length === 1) {
        month = '0' + month;
      }
      if (date.length === 1) {
        date = '0' + date;
      }

      this.editUser.birthday = year + month + date;
    },
    // ユーザーのプロフィールの登録ボタン押下時処理
    async onClickRegistProfile() {
      window.scrollTo(0, 0);
      // validation
      const api2 = new API();
      const resTest = await api2.get<usermodels.VUsers>('users');
      this.editUser2 = JSON.parse(JSON.stringify(resTest.data.users[0]));
      this.editUser2.sei = this.editUser.sei;
      this.editUser2.mei = this.editUser.mei;
      this.editUser2.seiKana = (this.editUser as any).sei_kana;
      this.editUser2.meiKana = (this.editUser as any).mei_kana;
      this.editUser2.gender = this.editUser.gender;
      this.editUser2.birthday = this.editUser.birthday;
      // console.log(this.editUser2);
      const editProfileSummary = this.editProfile.concat(this.editProfile2);
      if (validation.checkValues(this.editUser, editProfileSummary)) {
        return false;
      }
      // 値を設定
      const requestData: usermodels.VEditUserProfile = { user: this.editUser2 };
      // 登録実行
      const api = new API();
      const res = await api.put<usermodels.VEditUserProfile, usermodels.VUsers>('users/edit/profile', requestData);
      this.processAfterUpdate(res);
      this.formDataChangeFlg = false;
      this.formDataChangeFlgModal = false;
      // this.mode = NOC.SETTING.MODE.SELECT;
    },
    // 更新後の後処理
    async processAfterUpdate(res: ApiResult<usermodels.VUsers>, errMsg?: string) {
      if (res.result) {
        // this.onClickCancel();
        this.editFlag = false;
        this.accountEditFlag = false;
        const api = new API();
        const resUser = await api.get<usermodels.VEditUserProfile>('users/accountmanager');
        if (resUser.result) {
          this.selectUser = resUser.data.user;
        // this.mode = NOC.SETTING.MODE.SELECT;
        } else {
          this.$emit('change', NOC.APP.MODE.LOGIN);
        }

      } else {
        const msg = errMsg || '登録できませんでした。';
        this.$emit('info', msg);
      }
    },
    // モード判定
    // checkMode(mode: string) {
    //   return this.mode === mode;
    // },
    onInputItem(key: string, value: any) {
      if (key === 'prefCode') {
        this.checkPrefCode(value);
      }
    },
    async onClickUpdate(editData: models.IAccount): Promise<boolean> {
      // console.log(editData)

      // validation エラーの場合
      let errorNum = vi.checkValues(editData, this.items);
      errorNum += this.checkPrefCode(editData.prefCode); // 都道府県の必須チェック
      if (errorNum) {
        // this.$emit('info', '更新できませんでした。'); // 各項目にエラー表示してモーダル表示なし
        return false;
      }

      // api start
      const api = new API();
      const res = await api.put<models.IAccount, any>('account/edit', editData);
      // result
      if (res.result) {
        // 通信して成功時に再設定
        // res.data = editData; //TODO: メールアドレスの変更が更新されない不具合について、現行ではモーダルでメールを変更するようになっているためデザイン変更する
        this.accountData = res.data;
        this.editFlag = false;
      } else {
        this.$emit('info', '更新できませんでした。');
        return false;
      }

      return true;

    },
    async onClickAutoAddress() {
      // 住所自動入力

      // 入力チェック
      const postalItem = this.items.find((v) => v.key === 'postalCode');
      if (!postalItem || vi.checkValue(this.formData.postalCode, postalItem)) {
        return;
      }
      // 住所情報を取得
      const zipResult = await getAddressData(this.formData.postalCode);
      if (zipResult.success && zipResult.results) {
        const result = zipResult.results[0];
        this.formData.prefCode = Number(result.prefcode);
        this.formData.address = result.address2 + result.address3;
        this.formData.building = '';
        // 入力エラーをリセット
        const items = this.items.filter((v) => v.key === 'address' || v.key === 'building');
        for (const item of items) {
          item.error = '';
        }
      } else {
        // console.log(zipResult.message);
      }
    },
    async onClickCancel() {
      this.$watch('editUser', function(newVal) {
        if (!this.accountEditFlag) {
          return;
        }

        if (newVal.sei === this.editBeforeUser.sei
          && newVal.mei === this.editBeforeUser.mei
          && newVal.mei_kana === (this.editBeforeUser as any).mei_kana
          && newVal.sei_kana === (this.editBeforeUser as any).sei_kana
          && Number(newVal.gender) === Number(this.editBeforeUser.gender)
          && newVal.mail === this.editBeforeUser.mail
          && newVal.birthday === this.editBeforeUser.birthday
        ) {
          // this.formDataChangeFlg = false;
          this.editUserChangeFlg = false;
        } else {
          // this.formDataChangeFlg = true;
          this.editUserChangeFlg = true;
        }
      }, {
        deep: true,
        immediate: true,
      });


      this.$watch('formData', function(newVal) {
        if (newVal.companyName === this.accountData.companyName
          && newVal.branchName === this.accountData.branchName
          && newVal.mail === this.accountData.mail
          && newVal.billingMail === this.accountData.billingMail
          && newVal.tel === this.accountData.tel
          && newVal.postalCode === this.accountData.postalCode
          && newVal.postalCode === this.accountData.postalCode
          && newVal.prefCode === this.accountData.prefCode
          && newVal.prefecture === this.accountData.prefecture
          && newVal.address === this.accountData.address
          && newVal.building === this.accountData.building
        ) {
          this.formDataChangeFlg = false;
        } else {
          this.formDataChangeFlg = true;
        }
      }, {
        deep: true,
        immediate: true,
      });


      if (this.formDataChangeFlg || this.editUserChangeFlg) {
        this.formDataChangeFlgModal = true;
      } else {
        this.formData = JSON.parse(JSON.stringify(this.accountData));
        // console.log(JSON.parse(JSON.stringify(this.selectUser)))
        this.editUser = JSON.parse(JSON.stringify(this.selectUser));

        this.editFlag = false;
        this.accountEditFlag = false;
        this.editBeforeUser = {} as usermodels.IUser;
      }
    },
    backEdit() {
      window.scrollTo(0, 0);
      this.formDataChangeFlgModal = false;
      // this.mode = NOC.SETTING.MODE.EDIT_PROFILE;
    },
    quitEdit() {

      if (this.accountEditFlag) {
        // プロフィール変更画面から戻ったら比較用のオブジェクトを空にする
        this.editBeforeUser = {} as usermodels.IUser;
        this.editUserChangeFlg = false;
      }
      this.formDataChangeFlg = false;
      this.formDataChangeFlgModal = false;
      this.editFlag = false;
      this.accountEditFlag = false;
      // this.mode = NOC.SETTING.MODE.NORMAL;
      this.formData = JSON.parse(JSON.stringify(this.accountData));
      this.editUser = JSON.parse(JSON.stringify(this.selectUser));

    },
    async changeMail(data: appModels.IAuth) {
      const api = new API();
      const res = await api.put<appModels.IAuth, any>(`account/changeMail`, data);
      // console.log(res);
      if (res.result) {
        // logauto
        if (res.data.message) {
          this.$emit('info', res.data.message.error);
        } else {
          // console.log('logout');
          this.$emit('logout');
        }

      } else {
        this.$emit('info', '通信できませんでした。');
      }
    },
    checkPrefCode(prefCode: number): number {
      // 都道府県が「未選択」の場合は必須エラー
      const prefItem = this.items.find((v) => v.key === 'prefCode');
      if (!prefItem) {
        return 0;
      }
      const isError = prefCode === NOC.SELECT.NOSELECT.value;
      prefItem.error = isError ? '必須項目です。' : '';
      return Number(isError);
    },
  },
});

